<template>
    <main class="page home">

        <section class="auto first">
            <div class="inner">

                <div class="title">
                    <h1> 
                        Unlock the Power of <span>User Feedback.</span>
                    </h1>
                    <h2><span>The All-In-One Feedback Tool with</span> <span class="item">Feedback Boards</span>, <span class="item">Roadmaps</span>, <span class="item">Changelog</span>, <span>and</span> <span class="item">Satisfaction Surveys</span></h2>
                </div>
                <div class="callto">
                    <a href="https://app.sleekplan.com/sign-up/" class="btn ularge">
                        <span class="btn-icon">
                            <span>Sign up for free</span>
                            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><polyline points='268 112 412 256 268 400' style='fill:none;stroke:#FFF;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px'/><line x1='392' y1='256' x2='100' y2='256' style='fill:none;stroke:#FFF;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px'/></svg>
                        </span>
                    </a>
                    <span class="btn-sub">30-day trial · No credit card required</span>
                </div>
                <div class="items mobile-hidden">
                    <div class="item post fade-in">
                        <div class="item-inner">
                            <div class="item-user">
                                <picture>
                                    <source srcset="/assets/pages/home/user-1.webp" type="image/webp">
                                    <source srcset="/assets/pages/home/user-1.jpeg" type="image/jpeg"> 
                                    <img src="/assets/pages/home/user-1.jpeg" alt="Feedback User" width="50" height="50">
                                </picture>
                            </div>
                            <div class="item-content">
                                <div class="marker cyan">
                                    <span>Feature Request</span>
                                </div>
                                <div class="text">
                                    <span class="plain">Let us customize text colors</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item post fade-in">
                        <div class="item-inner">
                            <div class="item-user">
                                <picture>
                                    <source srcset="/assets/pages/home/user-2.webp" type="image/webp">
                                    <source srcset="/assets/pages/home/user-2.jpeg" type="image/jpeg"> 
                                    <img src="/assets/pages/home/user-2.jpeg" alt="Feedback User" width="50" height="50">
                                </picture>
                            </div>
                            <div class="item-content">
                                <div class="marker pink">
                                    <span>Bug report</span> <span class="status">#In Pogress</span>
                                </div>
                                <div class="text">
                                    <span class="plain">Videos are not loading</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item post fade-in">
                        <div class="item-inner">
                            <div class="item-user">
                                <picture>
                                    <source srcset="/assets/pages/home/user-3.webp" type="image/webp">
                                    <source srcset="/assets/pages/home/user-3.jpeg" type="image/jpeg"> 
                                    <img src="/assets/pages/home/user-3.jpeg" alt="Feedback User" width="50" height="50">
                                </picture>
                            </div>
                            <div class="item-content">
                                <div class="feed">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Notifications</title><path d="M427.68 351.43C402 320 383.87 304 383.87 217.35 383.87 138 343.35 109.73 310 96c-4.43-1.82-8.6-6-9.95-10.55C294.2 65.54 277.8 48 256 48s-38.21 17.55-44 37.47c-1.35 4.6-5.52 8.71-9.95 10.53-33.39 13.75-73.87 41.92-73.87 121.35C128.13 304 110 320 84.32 351.43 73.68 364.45 83 384 101.61 384h308.88c18.51 0 27.77-19.61 17.19-32.57zM320 384v16a64 64 0 01-128 0v-16" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>
                                    <span>New Subscriber</span>
                                </div>
                                <div class="text">
                                    <span class="user">Max</span>
                                    <span class="plain">subscribed to changelog updates</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item post fade-in">
                        <div class="item-inner">
                            <div class="item-user">
                                <picture>
                                    <source srcset="/assets/pages/home/user-4.webp" type="image/webp">
                                    <source srcset="/assets/pages/home/user-4.jpeg" type="image/jpeg"> 
                                    <img src="/assets/pages/home/user-4.jpeg" alt="Feedback User" width="50" height="50">
                                </picture>
                            </div>
                            <div class="item-content">
                                <div class="feed">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Heart</title><path d="M352.92 80C288 80 256 144 256 144s-32-64-96.92-64c-52.76 0-94.54 44.14-95.08 96.81-1.1 109.33 86.73 187.08 183 252.42a16 16 0 0018 0c96.26-65.34 184.09-143.09 183-252.42-.54-52.67-42.32-96.81-95.08-96.81z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/></svg>
                                    <span>New Rating</span>
                                </div>
                                <div class="text">
                                    <span class="user">Lara</span>
                                    <span class="plain">voted with</span>
                                    <span class="data">5 / 5</span>
                                    <span class="plain">at the pricing page</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item post fade-in">
                        <div class="item-inner">
                            <div class="item-user">
                                <picture>
                                    <source srcset="/assets/pages/home/user-5.webp" type="image/webp">
                                    <source srcset="/assets/pages/home/user-5.jpeg" type="image/jpeg"> 
                                    <img src="/assets/pages/home/user-5.jpeg" alt="Feedback User" width="50" height="50">
                                </picture>
                            </div>
                            <div class="item-content">
                                <div class="marker blue">
                                    <span>Integration request</span>
                                </div>
                                <div class="text">
                                    <span class="plain">We would love to see a ClickUp integration</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item post fade-in">
                        <div class="item-inner">
                            <div class="item-user">
                                <picture>
                                    <source srcset="/assets/pages/home/user-6.webp" type="image/webp">
                                    <source srcset="/assets/pages/home/user-6.jpeg" type="image/jpeg"> 
                                    <img src="/assets/pages/home/user-6.jpeg" alt="Feedback User" width="50" height="50">
                                </picture>
                            </div>
                            <div class="item-content">
                                <div class="feed">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Thumbs Up</title><path d="M320 458.16S304 464 256 464s-74-16-96-32H96a64 64 0 01-64-64v-48a64 64 0 0164-64h30a32.34 32.34 0 0027.37-15.4S162 221.81 188 176.78 264 64 272 48c29 0 43 22 34 47.71-10.28 29.39-23.71 54.38-27.46 87.09-.54 4.78 3.14 12 7.95 12L416 205" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="32"/><path d="M416 271l-80-2c-20-1.84-32-12.4-32-30h0c0-17.6 14-28.84 32-30l80-4c17.6 0 32 16.4 32 34v.17A32 32 0 01416 271zM448 336l-112-2c-18-.84-32-12.41-32-30h0c0-17.61 14-28.86 32-30l112-2a32.1 32.1 0 0132 32h0a32.1 32.1 0 01-32 32zM400 464l-64-3c-21-1.84-32-11.4-32-29h0c0-17.6 14.4-30 32-30l64-2a32.09 32.09 0 0132 32h0a32.09 32.09 0 01-32 32zM432 400l-96-2c-19-.84-32-12.4-32-30h0c0-17.6 13-28.84 32-30l96-2a32.09 32.09 0 0132 32h0a32.09 32.09 0 01-32 32z" fill="none" stroke="currentColor" stroke-miterlimit="10" stroke-width="32"/></svg>
                                    <span>New Upvote</span>
                                </div>
                                <div class="text">
                                    <span class="user">paul</span>
                                    <span class="plain">upvoted</span>
                                    <span class="data">Add screen capture function</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="item post fade-in">
                        <div class="item-inner">
                            <div class="item-user">
                                <picture>
                                    <source srcset="/assets/pages/home/user-2.webp" type="image/webp">
                                    <source srcset="/assets/pages/home/user-2.jpeg" type="image/jpeg"> 
                                    <img src="/assets/pages/home/user-2.jpeg" alt="Feedback User" width="50" height="50">
                                </picture>
                            </div>
                            <div class="item-content">
                                <div class="feed">
                                    <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Chatbubble</title><path d="M87.49 380c1.19-4.38-1.44-10.47-3.95-14.86a44.86 44.86 0 00-2.54-3.8 199.81 199.81 0 01-33-110C47.65 139.09 140.73 48 255.83 48 356.21 48 440 117.54 459.58 209.85a199 199 0 014.42 41.64c0 112.41-89.49 204.93-204.59 204.93-18.3 0-43-4.6-56.47-8.37s-26.92-8.77-30.39-10.11a31.09 31.09 0 00-11.12-2.07 30.71 30.71 0 00-12.09 2.43l-67.83 24.48a16 16 0 01-4.67 1.22 9.6 9.6 0 01-9.57-9.74 15.85 15.85 0 01.6-3.29z" fill="none" stroke="currentColor" stroke-linecap="round" stroke-miterlimit="10" stroke-width="32"/></svg>
                                    <span>New Comment</span>
                                </div>
                                <div class="text">
                                    <span class="user">Lia</span>
                                    <span class="plain">commented</span>
                                    <span class="data">ClickUp Integration</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div class="background mobile-hidden">
                <div><div></div></div>
                <div><div></div></div>
            </div>
        </section>

        <section class="small second transparent">
            <div class="inner">

                <div class="widget-wrapper animation delay">
                    <div class="widget">
                        <picture>
                            <source srcset="/assets/pages/home/widget-1x.webp 1x, /assets/pages/home/widget-2x.webp 2x" type="image/webp">
                            <source srcset="/assets/pages/home/widget-1x.jpg 1x, /assets/pages/home/widget-2x.jpg 2x" type="image/jpeg"> 
                            <img src="/assets/pages/home/widget-1x.jpg" alt="User Feedback Widget" width="350" height="643" class="theme-image" :class="{active: widget_mode == 'light'}">
                        </picture>
                        <picture>
                            <source srcset="/assets/pages/home/widget-dark-1x.webp 1x, /assets/pages/home/widget-dark-2x.webp 2x" type="image/webp">
                            <source srcset="/assets/pages/home/widget-dark-1x.jpg 1x, /assets/pages/home/widget-dark-2x.jpg 2x" type="image/jpeg"> 
                            <img src="/assets/pages/home/widget-dark-1x.jpg" alt="User Feedback Widget" width="350" height="643" class="theme-image" :class="{active: widget_mode == 'dark'}">
                        </picture>
                    </div>
                </div>

                <div class="desktop animation" :class="widget_mode">
                    <div class="desktop-bar">
                        <span></span><span></span><span></span>
                    </div>
                    <div class="desktop-url">
                        <div>feedback.company.io</div>
                    </div>
                    <div class="desktop-mode widget-mode">
                        <div class="light" :class="{active: widget_mode == 'light'}" v-on:click="load_widget_mode('light')">
                            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path d='M256,118a22,22,0,0,1-22-22V48a22,22,0,0,1,44,0V96A22,22,0,0,1,256,118Z'/><path d='M256,486a22,22,0,0,1-22-22V416a22,22,0,0,1,44,0v48A22,22,0,0,1,256,486Z'/><path d='M369.14,164.86a22,22,0,0,1-15.56-37.55l33.94-33.94a22,22,0,0,1,31.11,31.11l-33.94,33.94A21.93,21.93,0,0,1,369.14,164.86Z'/><path d='M108.92,425.08a22,22,0,0,1-15.55-37.56l33.94-33.94a22,22,0,1,1,31.11,31.11l-33.94,33.94A21.94,21.94,0,0,1,108.92,425.08Z'/><path d='M464,278H416a22,22,0,0,1,0-44h48a22,22,0,0,1,0,44Z'/><path d='M96,278H48a22,22,0,0,1,0-44H96a22,22,0,0,1,0,44Z'/><path d='M403.08,425.08a21.94,21.94,0,0,1-15.56-6.45l-33.94-33.94a22,22,0,0,1,31.11-31.11l33.94,33.94a22,22,0,0,1-15.55,37.56Z'/><path d='M142.86,164.86a21.89,21.89,0,0,1-15.55-6.44L93.37,124.48a22,22,0,0,1,31.11-31.11l33.94,33.94a22,22,0,0,1-15.56,37.55Z'/><path d='M256,358A102,102,0,1,1,358,256,102.12,102.12,0,0,1,256,358Z'/></svg>
                            <span>light</span>
                        </div>
                        <div class="dark" :class="{active: widget_mode == 'dark'}" v-on:click="load_widget_mode('dark')">
                            <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path d='M264,480A232,232,0,0,1,32,248C32,154,86,69.72,169.61,33.33a16,16,0,0,1,21.06,21.06C181.07,76.43,176,104.66,176,136c0,110.28,89.72,200,200,200,31.34,0,59.57-5.07,81.61-14.67a16,16,0,0,1,21.06,21.06C442.28,426,358,480,264,480Z'/></svg>
                            <span>dark</span>
                        </div>
                    </div>
                    <div class="desktop-video">
                        <picture>
                            <source srcset="/assets/pages/home/dashboard-1x.webp 1x, /assets/pages/home/dashboard-2x.webp 2x" type="image/webp">
                            <source srcset="/assets/pages/home/dashboard-1x.jpg 1x, /assets/pages/home/dashboard-2x.jpg 2x" type="image/jpeg"> 
                            <img src="/assets/pages/home/dashboard-1x.jpg" alt="User Feedback Tool" width="1000" height="570" class="theme-image" :class="{active: widget_mode == 'light'}">
                        </picture>
                        <picture>
                            <source srcset="/assets/pages/home/dashboard-dark-1x.webp 1x, /assets/pages/home/dashboard-dark-2x.webp 2x" type="image/webp">
                            <source srcset="/assets/pages/home/dashboard-dark-1x.jpg 1x, /assets/pages/home/dashboard-dark-2x.jpg 2x" type="image/jpeg"> 
                            <img src="/assets/pages/home/dashboard-dark-1x.jpg" alt="User Feedback Tool" width="1000" height="570" class="theme-image" :class="{active: widget_mode == 'dark'}">
                        </picture>
                    </div>
                </div>

                <div class="popup-wrapper animation delay">
                    <div class="popup">
                        <picture>
                            <source srcset="/assets/pages/home/popup-1x.webp 1x, /assets/pages/home/popup-2x.webp 2x" type="image/webp">
                            <source srcset="/assets/pages/home/popup-1x.jpg 1x, /assets/pages/home/popup-2x.jpg 2x" type="image/jpeg"> 
                            <img src="/assets/pages/home/popup-1x.jpg" alt="User Feedback Popup" class="theme-image" :class="{active: widget_mode == 'light'}">
                        </picture>
                        <picture>
                            <source srcset="/assets/pages/home/popup-dark-1x.webp 1x, /assets/pages/home/popup-dark-2x.webp 2x" type="image/webp">
                            <source srcset="/assets/pages/home/popup-dark-1x.jpg 1x, /assets/pages/home/popup-dark-2x.jpg 2x" type="image/jpeg"> 
                            <img src="/assets/pages/home/widget-dark-1x.jpg" alt="User Feedback Popup" class="theme-image" :class="{active: widget_mode == 'dark'}">
                        </picture>
                    </div>
                </div>

                <div class="shadow-outer">
                    <div class="shadow"></div>
                </div>
                
            </div>
        </section>

        <section class="light round third small">
            <div class="inner">
                
                <div class="companies full" v-if="companies.length > 0">
                    <div class="logo" v-for="(company, key) in companies" v-bind:key="key" :style="{height: company.height}">
                        <img :src="company.img">
                    </div>
                </div>

            </div>
        </section>

        <section class="white round">
            <div class="inner large">
                
                <div class="content-large center">
                    <h2>Kickstart <span class="sub">the feedback loop</span></h2>
                    <span>
                        Sleekplan is an all-in-one feedback tool that organizes user requests and brings feature voting boards, roadmaps, changelogs, and satisfaction surveys to your website.
                    </span>
                </div>

                <img class="feedback-circle" src="/assets/pages/home/feedback-circle.svg" width="226" height="150">
                
            </div>
        </section>

        <section class="light">
            <div class="inner large">
                
                <div class="content-large center">
                    <h2>One Easy-To-Use Solution, <span class="sub">loaded with powerful features</span></h2>
                    <span>All you need to manage successful products: Sleekplan is not just another feature voting tool, it rather covers the entire process from the idea to the shipped feature and everything in between.</span>
                </div>

                <div class="row feature-box">
                    <div class="col-xs-12 col-sm-3">
                        <div class="feature-inner">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M434.8 137.6L285.4 69.5c-16.2-7.4-42.7-7.4-58.9 0L77.2 137.6c-17.6 8-17.6 21.1 0 29.1l148 67.5c16.9 7.7 44.7 7.7 61.6 0l148-67.5c17.6-8 17.6-21.1 0-29.1zM225.2 375.2l-99.8-45.5c-4.2-1.9-9.1-1.9-13.3 0l-34.9 15.9c-17.6 8-17.6 21.1 0 29.1l148 67.5c16.9 7.7 44.7 7.7 61.6 0l148-67.5c17.6-8 17.6-21.1 0-29.1l-34.9-15.9c-4.2-1.9-9.1-1.9-13.3 0l-99.8 45.5c-16.9 7.7-44.7 7.7-61.6 0z"/><path d="M434.8 241.6l-31.7-14.4c-4.2-1.9-9-1.9-13.2 0l-108 48.9c-15.3 5.2-36.6 5.2-51.9 0l-108-48.9c-4.2-1.9-9-1.9-13.2 0l-31.7 14.4c-17.6 8-17.6 21.1 0 29.1l148 67.5c16.9 7.7 44.7 7.7 61.6 0l148-67.5c17.7-8 17.7-21.1.1-29.1z"/></svg>
                            </div>
                            <div>
                                <h3>Capture <b>Feedback</b></h3>
                                <p>Collect, discuss, and categorize feedback from your customer.</p>
                                <router-link to="/features/feedback">
                                    <span>Feedback Board</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/></svg>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-3">
                        <div class="feature-inner">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512.18 512.18" style="enable-background:new 0 0 512.18 512.18;" xml:space="preserve"><g><g><path d="M448.18,80h-320c-17.673,0-32,14.327-32,32s14.327,32,32,32h320c17.673,0,32-14.327,32-32S465.853,80,448.18,80z"/></g></g><g><g><path d="M64.18,112c-0.036-8.473-3.431-16.586-9.44-22.56c-12.481-12.407-32.639-12.407-45.12,0C3.61,95.414,0.215,103.527,0.18,112c-0.239,2.073-0.239,4.167,0,6.24c0.362,2.085,0.952,4.124,1.76,6.08c0.859,1.895,1.876,3.715,3.04,5.44c1.149,1.794,2.49,3.457,4,4.96c1.456,1.45,3.065,2.738,4.8,3.84c1.685,1.227,3.512,2.248,5.44,3.04c2.121,1.1,4.382,1.908,6.72,2.4c2.073,0.232,4.167,0.232,6.24,0c8.45,0.007,16.56-3.329,22.56-9.28c1.51-1.503,2.851-3.166,4-4.96c1.164-1.725,2.181-3.545,3.04-5.44c1.021-1.932,1.826-3.971,2.4-6.08C64.419,116.167,64.419,114.073,64.18,112z"/></g></g><g><g><path d="M64.18,256c0.238-2.073,0.238-4.167,0-6.24c-0.553-2.065-1.359-4.053-2.4-5.92c-0.824-1.963-1.843-3.839-3.04-5.6c-1.109-1.774-2.455-3.389-4-4.8c-12.481-12.407-32.639-12.407-45.12,0C3.61,239.414,0.215,247.527,0.18,256c0.062,4.217,0.875,8.388,2.4,12.32c0.802,1.893,1.766,3.713,2.88,5.44c1.217,1.739,2.611,3.348,4.16,4.8c1.414,1.542,3.028,2.888,4.8,4c1.685,1.228,3.511,2.249,5.44,3.04c1.951,0.821,3.992,1.412,6.08,1.76c2.047,0.459,4.142,0.674,6.24,0.64c2.073,0.239,4.167,0.239,6.24,0c2.036-0.349,4.024-0.94,5.92-1.76c1.981-0.786,3.861-1.807,5.6-3.04c1.772-1.112,3.386-2.458,4.8-4c1.542-1.414,2.888-3.028,4-4.8c1.23-1.684,2.251-3.51,3.04-5.44c1.093-2.124,1.9-4.384,2.4-6.72C64.426,260.167,64.426,258.073,64.18,256z"/></g></g><g><g><path d="M64.18,400c0.237-2.073,0.237-4.167,0-6.24c-0.553-2.116-1.359-4.157-2.4-6.08c-0.859-1.895-1.876-3.715-3.04-5.44c-1.112-1.772-2.458-3.386-4-4.8c-12.481-12.407-32.639-12.407-45.12,0c-1.542,1.414-2.888,3.028-4,4.8c-1.164,1.725-2.181,3.545-3.04,5.44c-0.83,1.948-1.421,3.99-1.76,6.08c-0.451,2.049-0.665,4.142-0.64,6.24c0.036,8.473,3.431,16.586,9.44,22.56c1.414,1.542,3.028,2.888,4.8,4c1.685,1.228,3.511,2.249,5.44,3.04c1.951,0.821,3.992,1.412,6.08,1.76c2.047,0.459,4.142,0.674,6.24,0.64c2.073,0.239,4.167,0.239,6.24,0c2.036-0.349,4.024-0.94,5.92-1.76c1.981-0.786,3.861-1.807,5.6-3.04c1.772-1.112,3.386-2.458,4.8-4c1.542-1.414,2.888-3.028,4-4.8c1.231-1.683,2.252-3.51,3.04-5.44c1.092-2.125,1.899-4.384,2.4-6.72C64.426,404.167,64.426,402.073,64.18,400z"/></g></g><g><g><path d="M480.18,224h-352c-17.673,0-32,14.327-32,32s14.327,32,32,32h352c17.673,0,32-14.327,32-32S497.853,224,480.18,224z"/></g></g><g><g><path d="M336.18,368h-208c-17.673,0-32,14.327-32,32c0,17.673,14.327,32,32,32h208c17.673,0,32-14.327,32-32C368.18,382.327,353.853,368,336.18,368z"/></g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
                            </div>
                            <div>
                                <h3>Keep a <b>Changelog</b></h3>
                                <p>Keep your users informed about your recent product updates. </p>
                                <router-link to="/features/changelog">
                                    <span>Changelog</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/></svg>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-3">
                        <div class="feature-inner">
                            <div class="icon">
                                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><path d='M48.17,113.34A32,32,0,0,0,32,141.24V438a32,32,0,0,0,47,28.37c.43-.23.85-.47,1.26-.74l84.14-55.05a8,8,0,0,0,3.63-6.72V46.45a8,8,0,0,0-12.51-6.63Z'/><path d='M212.36,39.31A8,8,0,0,0,200,46V403.56a8,8,0,0,0,3.63,6.72l96,62.42A8,8,0,0,0,312,466V108.67a8,8,0,0,0-3.64-6.73Z'/><path d='M464.53,46.47a31.64,31.64,0,0,0-31.5-.88,12.07,12.07,0,0,0-1.25.74l-84.15,55a8,8,0,0,0-3.63,6.72V465.51a8,8,0,0,0,12.52,6.63l107.07-73.46a32,32,0,0,0,16.41-28v-296A32.76,32.76,0,0,0,464.53,46.47Z'/></svg>
                            </div>
                            <div>
                                <h3>Share a <b>Roadmap</b></h3>
                                <p>Keep everyone informed about things you are working on.</p>
                                <router-link to="/features/roadmap">
                                    <span>Product Roadmap</span>
                                    <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/></svg>
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-3">
                        <div class="feature-inner">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M464.9 128H344.1c-8.3 0-15.1 6.6-15.1 14.8s6.8 14.8 15.1 14.8h83.7l-138 142.2-85.9-84.1c-2.9-2.8-6.6-4.3-10.7-4.3-4 0-7.8 1.5-10.7 4.3L36.2 358.8c-1.9 1.9-4.2 5.2-4.2 10.7 0 4.1 1.4 7.5 4.2 10.2 2.9 2.8 6.6 4.3 10.7 4.3 4 0 7.8-1.5 10.7-4.3L193.2 247l85.9 84.1c2.9 2.8 6.6 4.3 10.7 4.3 4 0 7.8-1.5 10.7-4.3l149.4-151.9v81.7c0 8.1 6.8 14.8 15.1 14.8s15.1-6.6 15.1-14.8V142.8c-.1-8.2-6.9-14.8-15.2-14.8z"/></svg>
                            </div>
                            <div>
                                <h3>Measure <b>Satisfaction</b></h3>
                                <p>Track your users satisfaction with CSAT and NPS®.</p>
                                <div class="links">
                                    <router-link to="/features/satisfaction">
                                        <span>CSAT</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/></svg>
                                    </router-link>
                                    <router-link to="/features/net-promoter-score">
                                        <span>NPS®</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/></svg>
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="section-seperator"></div>


                <div class="row preview-box">
                    <div class="col-xs-12 col-sm-4 preview-content">
                        <div class="preview-navigation">
                            <span><a v-on:click="box_1 = 'feedback'" :class="{active: box_1 == 'feedback'}">Feedback</a></span>
                            <span><a v-on:click="box_1 = 'changelog'" :class="{active: box_1 == 'changelog'}">Changelog</a></span>
                            <span><a v-on:click="box_1 = 'roadmap'" :class="{active: box_1 == 'roadmap'}">Roadmap</a></span>
                            <span><a v-on:click="box_1 = 'satisfaction'" :class="{active: box_1 == 'satisfaction'}">Satisfaction</a></span>
                        </div>
                        <div class="preview-content-text content-large">
                            <div class="pre-head">{{box_1_content.title}}</div>
                            <h2> {{box_1_content[box_1].title}}
                                <span v-if="box_1_content[box_1].title_sub !== false" class="sub">{{box_1_content[box_1].title_sub}}</span>
                            </h2>
                            <span v-if="box_1_content[box_1].description" v-html="box_1_content[box_1].description"></span>
                            <span v-if="box_1_content[box_1].list" class="list">
                                <span v-for="(item, key) in box_1_content[box_1].list" v-bind:key="key">{{item}}</span>
                            </span>
                            <a class="btn small" target="_blank" v-if="box_1_content[box_1].action" :href="box_1_content[box_1].action.link">{{box_1_content[box_1].action.text}}</a>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-8 preview">
                        <div class="desktop animation">
                            <div class="desktop-bar">
                                <span></span><span></span><span></span>
                            </div>
                            <div class="desktop-url">
                                <div></div>
                            </div>
                            <div class="desktop-video">
                                <video v-if="box_1_content[box_1].video" :key="box_1_content[box_1].video" autoplay="" class="lazy loaded" loop="" muted="" playsinline="" :poster="box_1_content[box_1].image" height="650" width="980">
                                    <source :data-src="box_1_content[box_1].video" type="video/mp4" :src="box_1_content[box_1].video">
                                </video>
                                <picture v-else>
                                    <source v-if="box_1_content[box_1].image_webp" :srcset="box_1_content[box_1].image_webp" type="image/webp">
                                    <source :srcset="box_1_content[box_1].image" type="image/jpeg"> 
                                    <img :src="box_1_content[box_1].image" height="650" width="980">
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>

                
                <div class="section-seperator"></div>


                <div class="row middle-xs">
                    <div class="col-xs-12">
                        <div class="content-large center">
                            <h2>Different Teams<span class="sub">have different needs</span></h2>
                        </div>
                    </div>
                </div>

                <div class="content-box">
                    <div class="content-navigation">
                        <span><a v-on:click="box_3 = 'product'" :class="{active: box_3 == 'product'}">Product</a></span>
                        <span><a v-on:click="box_3 = 'support'" :class="{active: box_3 == 'support'}">Support</a></span>
                        <span><a v-on:click="box_3 = 'development'" :class="{active: box_3 == 'development'}">Development</a></span>
                    </div>
                    <div class="content-table">
                        <div v-for="(box_content, key) in box_3_content[box_3]" v-bind:key="key">
                            <div class="icon">
                                <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/></svg>
                            </div>
                            <div class="text">
                                <h3>{{box_content.title}}</h3>
                                <span>{{box_content.description}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </section>

        <section class="white">
            <div class="inner large focus">
                
                <div class="row preview-box light">
                    <div class="col-xs-12 col-sm-4 preview-content">
                        <div class="preview-navigation">
                            <span><a v-on:click="box_2 = 'widget'" :class="{active: box_2 == 'widget'}">Widget</a></span>
                            <span><a v-on:click="box_2 = 'standalone'" :class="{active: box_2 == 'standalone'}">Standalone</a></span>
                            <span><a v-on:click="box_2 = 'iframe'" :class="{active: box_2 == 'iframe'}">Iframe</a></span>
                            <span><a v-on:click="box_2 = 'popup'" :class="{active: box_2 == 'popup'}">Popup</a></span>
                        </div>
                        <div class="preview-content-text content-large">
                            <div class="pre-head">{{box_2_content.title}}</div>
                            <h2> {{box_2_content[box_2].title}}
                                <span v-if="box_2_content[box_2].title_sub !== false" class="sub">{{box_2_content[box_2].title_sub}}</span>
                            </h2>
                            <span v-if="box_2_content[box_2].description" v-html="box_2_content[box_2].description"></span>
                            <span v-if="box_2_content[box_2].list" class="list">
                                <span v-for="(item, key) in box_2_content[box_2].list" v-bind:key="key">{{item}}</span>
                            </span>
                            <a class="btn small" target="_blank" v-if="box_2_content[box_2].action" :href="box_2_content[box_2].action.link">{{box_2_content[box_2].action.text}}</a>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-8 preview">
                        <div class="desktop animation">
                            <div class="desktop-bar">
                                <span></span><span></span><span></span>
                            </div>
                            <div class="desktop-url">
                                <div></div>
                            </div>
                            <div class="desktop-video">
                                <video v-if="box_2_content[box_2].video" :key="box_2_content[box_2].video" autoplay="" class="lazy loaded" loop="" muted="" playsinline="" :poster="box_2_content[box_2].image" height="650" width="980">
                                    <source :data-src="box_2_content[box_2].video" type="video/mp4" :src="box_2_content[box_2].video">
                                </video>
                                <picture v-else>
                                    <source v-if="box_2_content[box_2].image_webp" :srcset="box_2_content[box_2].image_webp" type="image/webp">
                                    <source :srcset="box_2_content[box_2].image" type="image/jpeg"> 
                                    <img :src="box_2_content[box_2].image" height="650" width="980">
                                </picture>
                            </div>
                        </div>
                    </div>
                </div>


                <div class="section-seperator"></div>


                <div class="row middle-xs">
                    <div class="col-xs-12 col-sm-7">
                        <div class="integrations-circle">
                            <div class="overflow"></div>
                            <div id="circle-one" class="circle">
                                <svg width="640" height="640" viewBox="0 0 640 640">
                                    <circle cx="320" cy="320" r="320" stroke="#00b3a4" stroke-width="1" fill="transparent"></circle>
                                </svg>
                                <span class="integration">
                                    <img src="https://storage.sleekplan.com/static/integrations/intercom.png" alt="Intercom Integration">                 
                                </span>
                                <span class="integration">
                                    <img src="https://storage.sleekplan.com/static/integrations/chrome.png" alt="Chrome Integration">
                                </span>
                            </div>
                            <div id="circle-two" class="circle">
                                <svg width="456" height="456" viewBox="0 0 456 456">
                                    <circle cx="228" cy="228" r="228" stroke="#5aa7de" stroke-width="1" fill="transparent"></circle>
                                </svg>
                                <span class="integration">
                                    <img src="https://storage.sleekplan.com/static/integrations/jira.png" alt="Jira Integration">
                                </span>
                                <span class="integration">
                                    <img src="https://storage.sleekplan.com/static/integrations/cloudflare.png" alt="Cloudflare Integration">
                                </span>
                                <span class="integration">
                                    <img src="https://storage.sleekplan.com/static/integrations/wordpress.png" alt="WordPress Integration">
                                </span>
                                <span class="integration">
                                    <img src="https://storage.sleekplan.com/static/integrations/zapier.png" alt="Zapier Integration">
                                </span>
                            </div>
                            <div id="circle-three" class="circle">
                                <svg width="272" height="272" viewBox="0 0 272 272">
                                    <circle cx="136" cy="136" r="136" stroke="#00b3a4" stroke-width="1" fill="transparent"></circle>
                                </svg>
                                <span class="integration">
                                    <img src="https://storage.sleekplan.com/static/integrations/github.png" alt="Github Integration">
                                </span>
                                <span class="integration">
                                    <img src="https://storage.sleekplan.com/static/integrations/slack.png" alt="Slack Integration">
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 col-sm-5">
                        <div class="content-large mobile-center">
                            <h2>Integrated
                                <span class="sub">with the tools you already use</span>
                            </h2>
                            <span>
                                Sleekplan understands the importance of supporting integration with your most used tools. Keep your stack aligned and integrate the tools and apps you already use with Sleekplan.
                                <br><br>
                                <a href="/integration/" class="btn">All integrations</a>
                            </span>
                        </div>
                    </div>
                </div>

            </div>
        </section>

        <section class="light round round-end integrations">
            <div class="inner large">

                <div class="user-trust">
                    <div class="content-large center">
                        <h2>Trusted by
                            <span class="sub">all-size Businesses</span>
                        </h2>
                    </div>
                    <div class="row ratings">
                        <div class="col-xs-12 col-sm-4">
                            <div class="rating">
                                <div class="rating-top">
                                    <picture>
                                        <source srcset="/assets/reviews/reviews-g2.webp" type="image/webp">
                                        <source srcset="/assets/reviews/reviews-g2.png" type="image/png"> 
                                        <img src="/assets/reviews/reviews-g2.png" class="rating-logo" alt="G2 logo" loading="lazy">
                                    </picture>
                                </div>
                                <div class="rating-stars">
                                    <div> 
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Star</title><path d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"/></svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Star</title><path d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"/></svg> 
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Star</title><path d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"/></svg> 
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Star</title><path d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"/></svg> 
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Star</title><path d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"/></svg>  
                                    </div>
                                    <span>4.8/5</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-4">
                            <div class="rating">
                                <div class="rating-top">
                                    <picture>
                                        <source srcset="/assets/reviews/reviews-capterra.webp" type="image/webp">
                                        <source srcset="/assets/reviews/reviews-capterra.png" type="image/png"> 
                                        <img src="/assets/reviews/reviews-capterra.png" class="rating-logo" alt="Capterra logo">
                                    </picture>
                                </div>
                                <div class="rating-stars">
                                    <div> 
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Star</title><path d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"/></svg>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Star</title><path d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"/></svg> 
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Star</title><path d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"/></svg> 
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Star</title><path d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"/></svg> 
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Star</title><path d="M394 480a16 16 0 01-9.39-3L256 383.76 127.39 477a16 16 0 01-24.55-18.08L153 310.35 23 221.2a16 16 0 019-29.2h160.38l48.4-148.95a16 16 0 0130.44 0l48.4 149H480a16 16 0 019.05 29.2L359 310.35l50.13 148.53A16 16 0 01394 480z"/></svg>  
                                    </div>
                                    <span>5/5</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-4">
                            <div class="row badges">
                                <div><img src="/assets/badge/g2-hp.svg" alt="G2 Award"></div>
                                <div><img src="/assets/badge/g2-2.svg" alt="G2 Award"></div>
                                <div><img src="/assets/badge/g2-3.svg" alt="G2 Award"></div>
                                <div><img src="/assets/badge/g2-4.svg" alt="G2 Award"></div>
                            </div>
                        </div>
                    </div>
                    <div class="row testimonial" v-if="testimonials.length > 0">
                        <div class="col-xs-12 col-sm-8" v-for="(testimonial, key) in testimonials_array" v-bind:key="key">
                            <div>
                                <div class="testimonial-company" v-if="testimonial.logo">
                                    <img :src="testimonial.logo">
                                </div>
                                <div class="comment"><div>{{testimonial.quote}}</div></div>
                                <div class="testimonial-by">
                                    <div class="testimonial-user">
                                        <img :src="testimonial.image">
                                        <div>
                                            <span>{{testimonial.name}}</span>
                                            <span>{{testimonial.role}}</span>
                                        </div>
                                    </div>
                                    <a href="/customers" class="testimonial-more" v-if="testimonial.logo">
                                        <span>Meet Our Customers</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" class="ionicon" viewBox="0 0 512 512"><title>Arrow Forward</title><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M268 112l144 144-144 144M392 256H100"/></svg>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                
            </div>
        </section>

        <section class="color end">
            <div class="inner large">
                
                <div class="content-large center">
                    <img src="@/assets/media/logo/logo-white.svg" title="Sleekplan logo">
                    <h2>Don't grope in the dark. <br> Know your customers' needs!</h2>
                    <div class="button-area">
                        <a href="https://app.sleekplan.com/sign-up/" class="btn ularge">
                            <span class="btn-icon">
                                <span>Track feedback, now</span>
                                <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512'><polyline points='268 112 412 256 268 400' style='fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px'/><line x1='392' y1='256' x2='100' y2='256' style='fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:48px'/></svg>
                            </span>
                        </a>
                        <span class="btn-sub">30-day trial · No credit card required</span>
                    </div>
                </div>
                
            </div>
            <div class="background">
                <div class="rect bottom-left"></div>
                <div class="rect bottom-right"></div>
            </div>
        </section>

    </main>
</template>

<script>
export default {


    /** ----------------------------------------------------
     * View => Base data
     ----------------------------------------------------- */
    data() {
        
        // data
		return {
            logo_white: require('@/assets/media/logo/logo-white.svg'),
            logo_default: require('@/assets/media/logo/logo.svg'),
            widget_mode: 'light',
            widget_video_light: require('@/assets/media/video/widget.mp4'),
            widget_video_dark: require('@/assets/media/video/widget_dark.mp4'),
            loop: 1,
            loop_timeout: false,
            mockup: {
                theme: 'light',
                brand_color: '#292b31'
            },
            companies: [
                {img: '/assets/testimonials/n26.png', height: false},
                {img: '/assets/testimonials/lambdatest.png', height: false},
                {img: '/assets/testimonials/yodeck.svg', height: false},
                {img: '/assets/testimonials/ooma.svg', height: '25px'},
                {img: '/assets/testimonials/decathlon.png', height: false},
            ],
            testimonials: [
                {
                    quote: "I have to say I love Sleekplans' tool for gathering user feedback, satisfaction & tracking product updates via the changelog & roadmap. Really handy for users of TuneRelease to see what we are building and be a part of the journey 🚀",
                    name: 'Luke Rynne Cullen',
                    role: 'Founder & CEO',
                    image: '/assets/testimonials/tunerelease-profile.jpg',
                    logo: '/assets/testimonials/tunerelease.png'
                },
            ],
            box_1: 'feedback',
            box_1_content: {
                title: 'Easy Administration',
                feedback: {
                    title: 'Feedback Board',
                    title_sub: 'A Voting Board with many Features',
                    description: false,
                    list: ['Private posts', 'Single sign-on', 'Internal comments', 'Vote on behalf', 'Internal tags', 'Moderation', 'Posts merging'],
                    action: false,
                    video: '/assets/pages/home/video-feedback.mp4',
                    image: '/assets/pages/home/video-feedback-poster.png',
                },
                changelog: {
                    title: 'Changelog',
                    title_sub: 'Publish and Send Updates in Minutes',
                    description: false,
                    list: ['Scheduled updates', 'Email notifications', 'In-app announcements', 'Call to action'],
                    action: false,
                    video: '/assets/pages/home/video-changelog.mp4',
                    image: '/assets/pages/home/video-changelog-poster.png',
                },
                roadmap: {
                    title: 'Roadmap',
                    title_sub: 'Communicate Progress to users',
                    description: false,
                    list: ['List or Kanban style', 'Custom roadmap statuses', 'Impact scoring', 'Notifications'],
                    action: false,
                    video: '/assets/pages/home/video-roadmap.mp4',
                    image: '/assets/pages/home/video-roadmap-poster.png',
                },
                satisfaction: {
                    title: 'Satisfaction',
                    title_sub: 'Measure and Analyze Trends in Customer Satisfaction',
                    description: false,
                    list: ['CSAT & NPS® surveys', 'In-app popups', 'Segmentation'],
                    action: false,
                    video: false,
                    image: '/assets/pages/home/preview-satisfaction.jpg',
                    image_webp: '/assets/pages/home/preview-satisfaction.webp',
                }
            },
            box_2: 'widget',
            box_2_content: {
                title: 'Sleekplan in Action',
                widget: {
                    title: 'Embeddable Widget',
                    title_sub: false,
                    description: 'Keep the feedback coming without interrupting your end-users. Enable them to quickly share feedback from within your web based app.',
                    list: false,
                    action: {
                        text: 'Try the widget',
                        link: 'https://sleekplan.github.io/sleekplan-demopage/?type=page&data='
                    },
                    video: '/assets/pages/home/video-widget.mp4',
                    image: '/assets/pages/home/video-widget-poster.png',
                },
                standalone: {
                    title: 'Standalone Website',
                    title_sub: false,
                    description: 'Share your Feedback board, Roadmap and Changelog using your own custom domain.',
                    list: false,
                    action: {
                        text: 'Try the website',
                        link: 'https://demo.sleekplan.app'
                    },
                    video: false,
                    image: '/assets/pages/home/preview-standalone.jpg',
                    image_webp: '/assets/pages/home/preview-standalone.webp',
                },
                iframe: {
                    title: 'Iframe',
                    title_sub: false,
                    description: "Either put Sleekplans' widget into your mobile app or embed a iframe somewhere on your website.",
                    list: false,
                    action: false,
                    video: false,
                    image: '/assets/pages/home/preview-iframe.jpg',
                    image_webp: '/assets/pages/home/preview-iframe.webp',
                },
                popup: {
                    title: 'Popups & Announcements',
                    title_sub: false,
                    description: 'Maximize user engagement using proactive popups. Ask for any kind of feedback, or invite users to subscribe to the changelog.',
                    list: false,
                    action: false,
                    video: '/assets/pages/home/video-popup.mp4',
                    image: '/assets/pages/home/video-popup-poster.png',
                }
            },
            box_3: 'product',
            box_3_content: {
                product: [
                    {
                        title: 'Organize all feedback in one place',
                        description: 'Launch a single, centralized place to capture, track, and organize internal and external feedback.'
                    },
                    {
                        title: 'Backing up product decisions',
                        description: 'Define user attributes and create custom segments to make wise product decisions.'
                    },
                    {
                        title: 'Manage product roadmaps',
                        description: 'Create and share an always-up-to-date roadmap and keep everyone in the loop.'
                    },
                    {
                        title: 'Test concepts and validate ideas',
                        description: 'Make sure that ideas and suggestions are worth pursuing. Collect  feedback and discuss possible solutions.'
                    }
                ],
                support: [
                    {
                        title: 'Empower internal teams to send product feedback',
                        description: 'Stop losing track of internal feedback. Enable your sales, success, and support team to pass along feedback.'
                    },
                    {
                        title: 'Capture feedback on behalf of users',
                        description: 'Teams can provide feedback on behalf of users. Thus, the user is always part of the notification flow.'
                    },
                    {
                        title: 'Help support team close issues quickly',
                        description: 'Ditch time-consuming emails and facilitate support using interactive thread-based discussions.'
                    },
                    {
                        title: 'Send feedback in your browser',
                        description: 'Using our Chrome extension makes it a smooth experience to capture user feedback, everywhere!'
                    },
                ],
                development: [
                    {
                        title: 'Track bugs and issues',
                        description: 'Turn bug submissions into actionable tasks that your team can tag, track, and assign.'
                    },
                    {
                        title: 'Integrate your teams favourite workflows',
                        description: 'Connect your teams favourite tools in Sleekplan with native integrations for Github, Jira, and ClickUp.'
                    },
                    {
                        title: 'Get advanced information',
                        description: 'Get info on browser, version, operating system and sync user ids with tools like Sentry for a deep dive.'
                    },
                ]
            }
        }

    },


    /** ----------------------------------------------------
     * View => Dynamical access to data
     ----------------------------------------------------- */
    computed: {

        testimonials_array() {

            var array = this.testimonials;
            var currentIndex = array.length,  randomIndex;

            // While there remain elements to shuffle...
            while (currentIndex != 0) {

                // Pick a remaining element...
                randomIndex = Math.floor(Math.random() * currentIndex);
                currentIndex--;

                // And swap it with the current element.
                [array[currentIndex], array[randomIndex]] = [
                array[randomIndex], array[currentIndex]];
            }

            return array.slice(0,3);

        },
        
    },


    /** ----------------------------------------------------
     * View => Methods
     ----------------------------------------------------- */
    methods: {

        /**
         *  load loop
         */
        load_loop() {

            // clear tieout
            clearTimeout( this.loop_timeout );

            // if reached end start from 1
            if( this.loop === 5 ) { this.loop = 1; }
            // else count up
            else { this.loop = this.loop + 1; }

            // set a timeout for 5 seconds
            this.loop_timeout = setTimeout( function() {
                // load next
                this.load_loop();
            }.bind(this), 5000 );
            
        },

        /**
         *  switch mode
         */
        load_widget_mode( mode ) {

            // set widget mode
            this.widget_mode = mode;

        },

    },
    

    /** ----------------------------------------------------
     * View => On Mount
     ----------------------------------------------------- */
    mounted() {

        // load loop
        this.load_loop();

    },


    /** ----------------------------------------------------
     * View => On Destroyed
     ----------------------------------------------------- */
    destroyed() {},


    /** ----------------------------------------------------
     * Header
     ----------------------------------------------------- */
    head: {
        // Meta title
        title: {
            inner: 'Sleekplan: The All-In-One User Feedback Tool',
            separator: ' ',
            complement: ' '
        },
        // Meta tags
        meta: [
            { 
                name: 'description', 
                content: 'Sleekplan is the all-in-one user feedback tool for your website and web based application. Collect, discuss and prioritize customer feedback, build a roadmap and keep a changelog, simple & all connected.',
                id: 'desc' 
            },
            { name: 'robots', content: 'index,follow' },
        ],
        // Link tags
        link: [
            { 
                rel: 'canonical', 
                href: 'https://sleekplan.com' + location.pathname, 
                id: 'canonical' 
            },
        ]
    }


}
</script>